import { CSSProperties, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { animated, SpringValue, useTransition } from "react-spring";

export function LoginStatusText(props: { text: string }) {
  const [text, setText] = useState<string>(props.text);

  useEffect(() => {
    if (props.text === text) return;
    setTimeout(() => setText(props.text), 250);
  }, [props]);

  const transitions = useTransition(text, {
    from: { opacity: 0, position: "absolute" },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 400 },
    key: text,
  });

  return (
    <div style={{ position: "relative", height: "2em", width: 200, display: "flex", justifyContent: "center", textAlign: "center", cursor: "pointer" }}>
      {transitions((style: { opacity: SpringValue<number>; position: SpringValue<string> }, item: string) => (
        <animated.div style={style as unknown as CSSProperties}>
          <Typography variant="h6">{item}</Typography>
        </animated.div>
      ))}
    </div>
  );
}
